import { AfterViewInit, ChangeDetectorRef, ContentChildren, Directive, Input, QueryList, inject } from '@angular/core';
import { BaseInputComponent } from '@common/components/input/base-input/base-input.component';

@Directive({
    selector: '[setEditMode]'
})
export class SetEditModeDirective implements AfterViewInit {
    private cdr = inject(ChangeDetectorRef);

    @Input() isEditMode: boolean = true;
    @ContentChildren(BaseInputComponent, { descendants: true }) inputs!: QueryList<BaseInputComponent<any>>;

    ngAfterViewInit(): void {
        this.applyEditMode();
    }

    applyEditMode(): void {
        if (this.inputs && this.inputs.length > 0)
            this.inputs.forEach((control) => (control.isEditMode = this.isEditMode));
        this.cdr.detectChanges();
    }
}
